import BCheckpanelCollection from "./BCheckpanelCollection";
import BApp from "./BApp";

export default class BCheckpanel
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.b-checkpanel`;
	static labelSelector = () => `${this.selector()}__label`;
	static inputSelector = () => `${this.selector()}__input`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = this.selector();
			if (event.target.matches(`${selector}`)) {
				try {
					event.target.querySelector(this.labelSelector()).click();
				} catch (error) {
					console.error(error);
				}
			}
		});

		document.addEventListener("change", event => {
			const selector = this.inputSelector();
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const collection = new BCheckpanelCollection(event.target.closest(BCheckpanelCollection.selector()));
				collection.getItems().forEach(item => {
					item.refreshState();
				});
				const item = new this(event.target.closest(this.selector()));
				item.focus();
				BApp.refresh();
			}
		});
	}

	getInput()
	{
		return this.el.querySelector(BCheckpanel.inputSelector());
	}

	getIsChecked()
	{
		return this.getInput().checked;
	}

	refreshState()
	{
		this.el.classList.toggle(`b-checkpanel--checked`, this.getIsChecked());
	}

	focus()
	{
		try {
			this.el.querySelector(`${BCheckpanel.selector()}__content input`).focus();
		} catch (error) {
			// Nevermind.
		}
	}
}
